// generated from 8_321 samples

import { z } from "zod";
import { common } from "../common";
import { filterGetBaseSchema } from "./filterGetBaseSchema";

export const lastReceivedEmailCampaignFilterGetSchema = z.object({
  ...filterGetBaseSchema.shape,
  filter_key: z.literal("last_received_email_campaign_filter"),
  comparison_key: z.enum([
    "6", // 6_179 (74.26%)
    "12", // 1_265 (15.20%)
    "4", // 589 (7.08%)
    "5", // 228 (2.74%)
    "3", // 60 (0.72%)
  ]),
  display_name: z.string(),
  // undefined: 5_389 (64.76%), defined 2_932 (35.24%)
  raw_value: z
    .union([
      // number samples: 2_270 (77.42%)
      // integer: 1_185 (52.20%)
      // avg: 6.88, min: 0, max: 365
      z.number().min(0),
      // string samples: 662 (22.58%)
      common.date,
    ])
    .optional(),
  value: z.union([
    // number samples: 6_792 (81.62%)
    // integer: 4_936 (72.67%)
    // avg: 4.87, min: 0, max: 365
    z.number().min(0),
    // string samples: 1_529 (18.38%)
    common.date,
  ]),
  varies_by_app_group: z.literal(false),
});
